import fetch from '@/axios/promise';
import  {PROJ_URL} from  '@/config/constant';

// 获取列表数据
export function page(query) {
  return invoke(query,'/getProjectPage','POST');
}

// 获取项目数据
export function detailData(query) {
  return invoke(query,'/getProjectData','POST');
}

// 项目流程提交
export function apprProcSubmit(query) {
  return invoke(query,'/apprProcSubmit','POST');
}
// 项目审批处理
export function approveProject(data) {
  return invoke(data,'/approveProject','POST');
}
// 获取列表数据
export function selectProjectList(query) {
  return invoke(query,'/getProjectPage','POST');
}
// 根据人员编码获取项目数据 ，参数 {personCode:''}
export function getPersonProjectData(query) {
  return invoke(query,'/getPersonProjectData','POST');
}
// sap同步调用
export function projSapSyncDeal(condition){
  return invoke(condition,'/projSapSyncDeal','POST')
}
// 根据条件获取每种项目类型的项目数量
export function queryProjectTypeCodeNumber(query){
  return invoke(query,'/queryProjectTypeCodeNumber','POST')
}
// 根据条件获取每种项目审批类型的项目数量
export function queryProjectStatusNumber(query){
  return invoke(query,'/queryProjectStatusNumber','POST')
}
// 根据条件获取每种项目类型的项目数量
export function queryProjStatusNumber(query){
  return invoke(query,'/queryProjStatusNumber','POST')
}
// 各个部门的项目数量
export function queryProjectGroupByDeptCode(query){
  return invoke(query,'/queryProjectGroupByDeptCode','POST')
}
//根据条件查询相关数据
export function queryProjectParams(query) {
  return invoke(query,'/queryProjectParams','POST');
}
//根据条件查询项目经理
export function queryProjectManagerByParams(query) {
  return invoke(query,'/queryProjectManagerByParams','POST');
}
function invoke(query,url,method){
  return fetch({
    url: PROJ_URL+url,
    method: method,
    params: query
  });
}


// WEBPACK FOOTER //
// ./src/api/pm/project.js